import { render, staticRenderFns } from "./borrowing-spare-part.vue?vue&type=template&id=1b23ed2c&scoped=true&"
import script from "./borrowing-spare-part.vue?vue&type=script&lang=js&"
export * from "./borrowing-spare-part.vue?vue&type=script&lang=js&"
import style0 from "./borrowing-spare-part.vue?vue&type=style&index=0&id=1b23ed2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b23ed2c",
  null
  
)

export default component.exports